import React, {Component} from 'react'
import propTypes from 'prop-types'
import {isNil, get} from 'lodash'
import Drawer from '@material-ui/core/Drawer'
import ListSubheader from '@material-ui/core/ListSubheader'
import Button from 'components/button'
import EditableFieldList from 'components/editableFieldList'
import {prefix} from 'helpers/component'
import {t} from "helpers/language"

const getClassName = prefix('editablePivotTable-bulkEditor-')

class BulkEditor extends Component {
  state = {
    addedFields: [],
    addedField: null,
    editedData: {},
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    if (this.props.open !== nextProps.open) {
      this.reset()
    }
  }

  reset = () => {
    this.setState({editedData: {}})
  }

  change = (column, value) => {
    if (column.key === '_') {
      if (value) this.addField(value)
    } else {
      const {editedData} = this.state
      let cur = editedData[column.key]
      if (isNil(cur)) cur = this.getCurrentValue(column)
      if (isNil(cur)) cur = null
      if (isNil(value)) value = null

      if (value !== cur) {
        this.setState({
          editedData: {
            ...editedData,
            [column.key]: value,
          },
        })
      }
    }
  }

  getCurrentValue = (column, asText = false) => {
    const {data} = this.props
    if (data.length === 0) return asText ? t('Not Specified') : null

    // Return the same value across all entities
    let ret = column.data(data[0])
    if (!data.slice(1).every(d => column.data(d) === ret)) return asText ? t('Various') : null

    if (!isNil(ret) && column.values) ret = get(column.values.find(v => v.value === ret), 'label')
    return isNil(ret) ? (asText ? t('Not Specified') : null) : ret
  }

  save = () => {
    this.props.onSave(this.state.editedData)
  }

  addField = (field) => {
    this.setState({
      addedFields: [...this.state.addedFields, field],
      addedField: field,
    }, this.resetAddedField)
  }

  resetAddedField = () => {
    this.setState({addedField: null})
  }

  render() {
    const {columns, visibleColumns, data, open, onClose} = this.props
    const {addedFields, addedField, editedData} = this.state
    let content

    if (open) {
      const fields = visibleColumns.concat(addedFields).map(c => ({
        ...columns[c],
        key: c,
      })).filter(c => c.editable && c.canBulkEdit !== false).map(col => {
        const value = editedData[col.key]
        const placeholder = this.getCurrentValue(col, true)
        const dataType = col.dataTypeForEntity ? col.dataTypeForEntity(data[0]) : col.dataType || 'String'

        return {
          ...col,
          label: col.label || col.alias,
          dataType,
          values: col.values ? col.values.map(v => ({key: v.value, label: v.label})) : null,
          placeholder,
          value,
        }
      })

      let otherFields = Object.keys(columns).filter(c =>
        columns[c].editable
        && columns[c].canBulkEdit !== false
        && !fields.some(f => f.key === c)
      )
      otherFields = otherFields.sort()
      otherFields = otherFields.map(c => {
        const col = columns[c]
        return {
          key: c,
          label: col.label || col.alias,
        }
      })

      if (otherFields.length > 0) {
        fields.push({
          key: '_',
          showLabel: false,
          dataType: 'List',
          label: t('More Fields...'),
          placeholder: t('More Fields...'),
          values: otherFields,
          value: addedField,
        })
      }

      content = (
        <div>
          <ListSubheader style={{paddingLeft: '16px'}}>
            {t(`Edit {1} Items`, data.length)}
          </ListSubheader>
          <EditableFieldList
            fields={fields}
            onChange={this.change}
          />
          <div className={getClassName('buttons')}>
            <Button
              flat
              label="Cancel"
              onClick={onClose}
            />
            <Button
              primary
              label={t("Apply")}
              onClick={this.save}
              disabled={Object.keys(editedData).length === 0}
            />
          </div>
        </div>
      )
    }

    return (
      <Drawer
        anchor="right"
        open={open}
        onClose={onClose}
        PaperProps={{style: {width: 450}}}
      >
        {content}
      </Drawer>
    )
  }
}

BulkEditor.propTypes = {
  open: propTypes.bool.isRequired,
  columns: propTypes.object.isRequired,
  visibleColumns: propTypes.array.isRequired,
  data: propTypes.array.isRequired,
  onSave: propTypes.func.isRequired,
  onClose: propTypes.func.isRequired,
}

export default BulkEditor
